import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { roomsQueryOptions } from '@/core/components/sites/site/rooms/roomQueryOptions'
import { roomsSearchSchema } from '@/core/components/sites/site/rooms/rooms.types'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/sites/$siteId/rooms/')(
  {
    validateSearch: (search) => roomsSearchSchema.parse(search),
    beforeLoad: ({ context: { auth } }) => {
      if (auth.isExpired()) {
        return
      }
      if (!auth.isAuthenticated) {
        throw redirect({
          to: '/',
        })
      }
      if (
        auth.user?.role === Role['Front-Desk'] ||
        auth.user?.role === Role['Blogger']
      ) {
        throw redirect({
          to: '/dashboard',
        })
      }
    },
    loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.ensureQueryData(roomsQueryOptions(siteId, auth.token!))
    },
    pendingComponent: LoadingList,
    errorComponent: ErrorComponent,
  }
)
